import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "base_screen_header"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, null, -1);

const _hoisted_3 = {
  class: "base_main_margin_top"
};
import StatusBar from "@com/StatusBar.vue";
import ExamineTable from '@com/examine/ExamineTable.vue';
import { ref, reactive } from "vue";
import { Search } from "@element-plus/icons-vue";
import useRoute from "@util/router";
import api from "@api/examine";
export default {
  __name: 'DepositExamine',

  setup(__props) {
    const config = {
      type: 'deposit'
    };
    const route = useRoute();
    const data = ref([]);
    const total = ref(0);
    route.watchRouter("depositexamine", () => {
      getStatistics();
      getList();
    });
    const statusList = reactive([{
      label: '全部',
      value: 'all',
      total: 0
    }, {
      label: '待审批',
      value: '1007002',
      total: 0
    }, {
      label: '已通过',
      value: '1007004',
      total: 0
    }, {
      label: '已驳回',
      value: '1007003',
      total: 0
    }]);
    const login = ref(route.query().login || '');
    const name = ref(route.query().name || '');

    function searchName(val) {
      route.replaceQuery('name', val);
    }

    function searchLogin(val) {
      route.replaceQuery('login', val);
    }

    getList();

    function getList() {
      let routeQuery = route.query();
      api.list(config.type, {
        memberName: routeQuery.name,
        flowStatus: routeQuery.status,
        memberLoginName: routeQuery.login,
        page: routeQuery.p,
        size: routeQuery.s
      }, val => {
        total.value = val.total;
        data.value = val.list.map(e => {
          if (e.flowType === '1006007') {
            e.flowTypeVal = '调整储值余额';
          } else {
            e.flowTypeVal = '解冻储值余额';
          }

          if (e.changeMoney > 0) {
            e.changeVal = '增加';
          } else {
            e.changeVal = '减少';
          } // 1007001草稿 1007002待审批 1007003被驳回 1007004审批通过


          switch (e.flowStatus) {
            case "1007001":
              e.state = "草稿";
              break;

            case "1007002":
              e.state = "待审批";
              break;

            case "1007003":
              e.state = "已驳回";
              break;

            case "1007004":
              e.state = "已通过";
              break;
          }

          return e;
        });
      });
    }

    getStatistics();

    function getStatistics() {
      let routeQuery = route.query();
      api.depositNum(routeQuery.name, routeQuery.login, val => {
        statusData(val);
      });
    }

    function statusData(val) {
      statusList.forEach((e, i) => {
        e.total = val[i];
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createBlock(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_form, {
          inline: true,
          class: "base_search_form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: name.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => name.value = $event),
              "onKeyup[native]": searchName,
              onChange: searchName,
              placeholder: "会员名称",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: login.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => login.value = $event),
              "onKeyup[native]": searchLogin,
              onChange: searchLogin,
              placeholder: "会员账号",
              clearable: "",
              "suffix-icon": _unref(Search)
            }, null, 8, ["modelValue", "suffix-icon"])]),
            _: 1
          })]),
          _: 1
        })]), _createVNode(StatusBar, {
          data: statusList,
          default: "all"
        }, null, 8, ["data"]), _createElementVNode("div", _hoisted_3, [_createVNode(ExamineTable, {
          type: config.type,
          data: data.value,
          total: total.value,
          onGetData: getList
        }, null, 8, ["type", "data", "total"])])]),
        _: 1
      });
    };
  }

};